module.exports = __webpack_public_path__ + "static/img/RAT-1R_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAT-1R_1.png
// module id = emg7
// module chunks = 0